/* eslint-disable */
// vex 3.0 does not have TypeScript types at the time of writing (May 2017).
// By declaring it an already-declared, untyped variable, we at least won't
// cause TypeScript compilation errors.
/* eslind-disable */
import * as vex from '../vendor/vex.combined.min.js';
// declare let vex: any;
var isUploadingFile = false;
jQuery(function () {
    var dialogInstance;
    vex.defaultOptions.className = 'vex-theme-mitthus';
    var optionsForDialog = function (template) {
        var $content = $(template.innerHTML);
        var okCaption = template.getAttribute('ok-button') || 'Klar';
        var cancelCaption = template.getAttribute('cancel-button') || 'Avbryt';
        var noCancelButton = template.getAttribute('no-cancel-button') != null && template.getAttribute('no-cancel-button') == 'true' ? 'hidden' : '';
        var dataclassname = template.getAttribute('data-class-name') != null ? template.getAttribute('data-class-name') : '';
        if ($content.is('form')) {
            return {
                input: $content.html(),
                buttons: [
                    {
                        type: 'submit',
                        text: okCaption,
                        className: 'button button--primary form__submit'
                    },
                    $.extend({}, vex.dialog.buttons.NO, {
                        text: cancelCaption,
                        className: 'button button--third form__cancel '
                    }),
                ],
                showCloseButton: true,
                callback: formSubmissionCallback($content),
                contentClassName: 'dialog',
                beforeClose: function () {
                    var context = this;
                    if (context.value != null && context.value !== false) {
                        var validation = $content.attr('data-validation-function');
                        if (validation !== undefined && window.hasOwnProperty(validation)) {
                            var validationFunction = window[validation];
                            return validationFunction(this);
                        }
                        else {
                            return true;
                        }
                    }
                },
                focusFirstInput: false
            };
        }
        else {
            return {
                input: template.innerHTML,
                className: 'vex-theme-mitthus ' + dataclassname,
                buttons: [
                    {
                        type: 'submit',
                        text: 'Okej',
                        className: 'button button--primary form__submit'
                    },
                    $.extend({}, vex.dialog.buttons.NO, {
                        text: cancelCaption,
                        className: 'button button--third form__cancel ' + noCancelButton
                    })
                ],
                showCloseButton: true,
            };
        }
    };
    var formSubmissionCallback = function ($form) {
        return function (data) {
            // Ignore Vex' parsed form data; Vex does not correctly parse complex input
            // names. jQuery, however, does.
            //
            // Input name:     "MaintenanceActions[13].PlannedCompletionYear"
            // Vex form data:  { "MaintenanceActions": [] }
            // jQuery:         { "MaintenanceActions[13].PlannedCompletionYear": "(value)" }
            var formData = $(dialogInstance.contentEl).find('form').serializeArray();
            if (!formData) {
                return;
            }
            if (canUploadUsingAjax($form)) {
                uploadUsingAjax($form, formData);
            }
            else {
                uploadWithoutAjax($form);
                //To prevent file upload cancellation
                window.setTimeout(setUploadingFile, 100);
            }
        };
    };
    var setUploadingFile = function () {
        isUploadingFile = true;
    };
    var unsetUploadingFile = function () {
        isUploadingFile = false;
    };
    var canUploadUsingAjax = function ($form) {
        // For security reasons, files cannot be uploaded using Ajax.
        return $form.find('input[type=file]').length == 0;
    };
    var uploadWithoutAjax = function ($form) {
        var vexForm = $('.vex-dialog-form');
        vexForm.attr('action', $form.attr('action'));
        vexForm.attr('method', $form.attr('method'));
        vexForm.attr('enctype', $form.attr('enctype'));
        vexForm.submit();
    };
    var uploadUsingAjax = function ($form, data) {
        $.ajax({
            url: $form.attr('action'),
            method: $form.attr('method') || 'POST',
            data: data
        }).done(function (response) { return handleAjaxResponse($form, response); }).fail(function (response) { return handleAjaxFailure($form, response); });
    };
    var handleAjaxResponse = function ($form, response) {
        if (response.message) {
            alert(response.message);
        }
        else if (response.redirect) {
            document.location.href = response.redirect;
        }
        else {
            document.location.reload();
        }
    };
    var handleAjaxFailure = function ($form, response) {
        alert("Hoppsan! N\u00E5got gick fel n\u00E4r vi f\u00F6rs\u00F6kte spara detta. (" + response.status + ")");
    };
    var triggerDialogOpenEvent = function (element) {
        $(element).trigger('dialogOpen');
        //Activate eventual semantic-ui dropdowns
        var dropdown;
        dropdown = $(element).find('.ui.dropdown');
        var str = dropdown.attr('data-pre-selected');
        if (str != null) {
            dropdown.dropdown('set selected', str.split(','));
        }
        else {
            dropdown.dropdown();
        }
    };
    $('body').on('click', 'a[href^=\'#\']', function (event) {
        var anchor = $(event.target).closest('a');
        var targetId = anchor.prop('hash').replace('#', '');
        var dialog = document.getElementById(targetId);
        if (dialog && dialog.tagName.toLowerCase() == 'script') {
            dialogInstance = vex.dialog.open(optionsForDialog(dialog));
            triggerDialogOpenEvent(dialogInstance.rootEl);
            event.preventDefault();
            event.stopPropagation();
        }
    });
    $(window).on('beforeunload', function () {
        if (isUploadingFile) {
            // Guess when file will be uploaded since we can't get a callback
            window.setTimeout(unsetUploadingFile, 2000);
            return 'Din fil håller fortfarande på att laddas upp, vill du avbryta?';
        }
    });
    //
    // Dialog for new components
    //
    var optionsForNewDialog = function (template) {
        var $content = $(template.innerHTML);
        var okCaption = template.getAttribute('ok-button') || 'Klar';
        return {
            input: $content.html(),
            buttons: [
                {
                    type: 'submit',
                    text: okCaption,
                    className: 'button button--primary form__submit',
                },
            ],
            contentClassName: 'dialog',
            overlayClosesOnClick: false,
            showCloseButton: false,
            escapeButtonCloses: false,
            callback: formSubmissionCallback($content),
            beforeClose: function () {
                var context = this;
                if (context.value != null && context.value !== false) {
                    var validation = $content.attr('data-validation-function');
                    if (validation !== undefined && window.hasOwnProperty(validation)) {
                        var validationFunction = window[validation];
                        return validationFunction(this);
                    }
                    else {
                        return true;
                    }
                }
            },
            focusFirstInput: false
        };
    };
    $(document).ready(function () {
        var dialog = document.getElementById('missing-editable-components-dialog');
        if (dialog && dialog.tagName.toLowerCase() == 'script') {
            dialogInstance = vex.dialog.open(optionsForNewDialog(dialog));
            triggerDialogOpenEvent(dialogInstance.rootEl);
        }
    });
});
